module.exports = __webpack_public_path__ + "img/image01.72a0ccf4.jpg";